import { useQuery } from "react-query";
import { getActiveRoles } from "../../../../actions/Utilities/CustomReport/index";

export const useGetActiveRoles = () => {
  return useQuery("GetActiveRoles", getActiveRoles, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
